'use strict';
const assert = require('assert');
const RequestConfiguration = require('../request-configuration-manager');
const chai = require('chai');

const expect = chai.expect;
/* eslint-disable  no-undef */ /* eslint-disable  no-unused-vars */
describe('RequestConfiguration', () => {
  it('Creates the correct instance the class', (done) => {
    const fakeSDKConfiguration = {};
    const requestConfiguration = new RequestConfiguration(fakeSDKConfiguration);
    done();
  });
  it('Correct api setup', (done) => {
    const fakeSDKConfiguration = {
      Apis: {
        UserCredentials: {
          Path: 'https://login.windows.net/{0}/oauth2/token',
          Method: 'POST',
          Authorization: true,
          PathParams: {
            Domain: 'default',
          },
        },
      },
    };
    const requestConfiguration = new RequestConfiguration(fakeSDKConfiguration);
    requestConfiguration.setApi('UserCredentials');
    assert(typeof requestConfiguration.Headers === 'object');
    expect(requestConfiguration).to.have.property('Path');
    expect(requestConfiguration).to.have.property('Method');
    expect(requestConfiguration).to.have.property('Authorization');
    done();
  });
  it('if the object sdkConfiguration does not have the variable path, return an error', (done) => {
    const fakeSDKConfiguration = {
      Apis: {
        UserCredentials: {          /* missing path */
          Method: 'POST',
          Authorization: true,
          PathParams: {
            Domain: 'default',
          },
        },
      },
    };
    const requestConfiguration = new RequestConfiguration(fakeSDKConfiguration);
    try {
      requestConfiguration.setApi('UserCredentials');
    } catch (err) {
      assert(err.message === 'Expected path in sdkConfiguration');
      done();
    }
  });
  it('if the object sdkConfiguration does not have the variable method or the method is not correct, return an error', (done) => {
    const fakeSDKConfiguration = {
      Apis: {
        UserCredentials: {
          Path: 'https://login.windows.net/{0}/oauth2/token',
          Method: 'POSTS',            /* invalid parameter */
          Authorization: true,
          PathParams: {
            Domain: 'default',
          },
        },
      },
    };
    const requestConfiguration = new RequestConfiguration(fakeSDKConfiguration);
    try {
      requestConfiguration.setApi('UserCredentials');
    } catch (err) {
      assert(err.message === 'Expected Method in sdkConfiguration');
      done();
    }
  });
  it('if the Authorization in the sdkConfiguration is not boolean, return an error', (done) => {
    const fakeSDKConfiguration = {
      Apis: {
        UserCredentials: {
          Path: 'https://login.windows.net/{0}/oauth2/token',
          Method: 'POST',
          Authorization: 'true',        /* invalid parameter */
          PathParams: {
            Domain: 'default',
          },
        },
      },
    };
    const requestConfiguration = new RequestConfiguration(fakeSDKConfiguration);
    try {
      requestConfiguration.setApi('UserCredentials');
    } catch (err) {
      assert(err.message === 'Authorization must be a boolean');
      done();
    }
  });
  it('it must set the default headers for Microsoft', (done) => {
    const fakeSDKConfiguration = {
      Apis: {
        UserCredentials: {
          Path: 'https://login.windows.net/{0}/oauth2/token',
          Method: 'POST',
          Authorization: true,
          PathParams: {
            Domain: 'default',
          },
        },
      },
    };
    const requestConfiguration = new RequestConfiguration(fakeSDKConfiguration);
    requestConfiguration.setApi('UserCredentials');
    expect(requestConfiguration).to.have.property('Headers');
    expect(requestConfiguration.Headers).to.have.property('Accept');
    expect(requestConfiguration.Headers).to.have.property('MS-RequestId');
    expect(requestConfiguration.Headers).to.have.property('MS-CorrelationId');
    expect(requestConfiguration.Headers).to.have.property('Content-Type');
    done();
  });
  it('getRequestOptions, if method, uri, form, body, headers is not set, return an error', (done) => {
    const fakeSDKConfiguration = {
      Apis: {
        UserCredentials: {
          Path: 'https://login.windows.net/{0}/oauth2/token',
          Method: 'POST',
          Authorization: true,
          PathParams: {
            Domain: 'default',
          },
        },
      },
    };
    const requestConfiguration = new RequestConfiguration(fakeSDKConfiguration);
    try {
      requestConfiguration.getRequestOptions();
    } catch (err) {
      assert(err.message === 'Method param is not set');
      done();
    }
  });
  it('getOptions, it must receive an object', (done) => {
    const fakeSDKConfiguration = {
      Apis: {
        UserCredentials: {
          Path: 'https://login.windows.net/{0}/oauth2/token',
          Method: 'POST',
          Authorization: true,
          PathParams: {
            Domain: 'default',
          },
        },
      },
    };
    const requestConfiguration = new RequestConfiguration(fakeSDKConfiguration);
    try {
      requestConfiguration.getOptions('not an object');
    } catch (err) {
      assert(err.message === 'Options must be an object');
      done();
    }
  });
  it('getOptions, if option received is form, it must call the setForm function wich receives an object', (done) => {
    const fakeSDKConfiguration = {
      Apis: {
        UserCredentials: {
          Path: 'https://login.windows.net/{0}/oauth2/token',
          Method: 'POST',
          Authorization: true,
          PathParams: {
            Domain: 'default',
          },
        },
      },
    };
    const requestConfiguration = new RequestConfiguration(fakeSDKConfiguration);

    requestConfiguration.setApi('UserCredentials');
    requestConfiguration.getOptions({ form: { name: 'value' } });
    expect(requestConfiguration).to.have.property('Form');
    expect(requestConfiguration.Form).to.have.property('name');
    done();

  });
  it('getOptions, if option received is queryParams, it must call the setQuery function wich receives an array that contains an object for each query param', (done) => {
    const fakeSDKConfiguration = {
      Apis: {
        UserCredentials: {
          Path: 'https://login.windows.net/{0}/oauth2/token',
          Method: 'POST',
          Authorization: true,
          PathParams: {
            Domain: 'default',
          },
        },
      },
    };
    const requestConfiguration = new RequestConfiguration(fakeSDKConfiguration);
    requestConfiguration.setApi('UserCredentials');
    requestConfiguration.getOptions({ queryParams: [{ name: 'villa' }, { size: '2' }, { state: 'JA' }] });
    assert(requestConfiguration.Uri === 'https://login.windows.net/{0}/oauth2/token?name=villa&size=2&state=JA');
    done();
  });
  it('getOptions, if option received is queryParams, it must call the setQuery function wich receives an array that contains an object for each query param', (done) => {
    const fakeSDKConfiguration = {
      Apis: {
        UserCredentials: {
          Path: 'https://login.windows.net/{0}/oauth2/token',
          Method: 'POST',
          Authorization: true,
          PathParams: {
            Domain: 'default',
          },
        },
      },
    };
    const requestConfiguration = new RequestConfiguration(fakeSDKConfiguration);
    requestConfiguration.setApi('UserCredentials');
    try {
      requestConfiguration.getOptions({ queryParams: [{ name: 'villa' }, '2', { state: 'JA' }] });
    } catch (error) {
      assert(error.message === 'Property inside queryParams must be an object');
      done();
    }
  });
  it('getOptions, if option received is queryParams, it must call the setQuery function wich receives an array that contains an object for each query param', (done) => {
    const fakeSDKConfiguration = {
      Apis: {
        UserCredentials: {
          Path: 'https://login.windows.net/{0}/oauth2/token',
          Method: 'POST',
          Authorization: true,
          PathParams: {
            Domain: 'default',
          },
        },
      },
    };
    const requestConfiguration = new RequestConfiguration(fakeSDKConfiguration);
    requestConfiguration.setApi('UserCredentials');
    try {
      requestConfiguration.getOptions({ queryParams: { name: '2', size: 1 } });
    } catch (error) {
      assert(error.message === 'Expected queryParams to be an array');
      done();
    }
  });
  it('getOptions, if option received is bodyParams, must set the body, body must be an object', (done) => {
    const fakeSDKConfiguration = {
      Apis: {
        UserCredentials: {
          Path: 'https://login.windows.net/{0}/oauth2/token',
          Method: 'POST',
          Authorization: true,
          PathParams: {
            Domain: 'default',
          },
        },
      },
    };
    const requestConfiguration = new RequestConfiguration(fakeSDKConfiguration);

    requestConfiguration.setApi('UserCredentials');
    requestConfiguration.getOptions({ bodyParams: { name: 'value' } });
    expect(requestConfiguration).to.have.property('Body');
    expect(requestConfiguration.Body).to.have.property('name');
    done();
  });
  it('getOptions, if option received is bodyParams, must set the body, body must be an object', (done) => {
    const fakeSDKConfiguration = {
      Apis: {
        UserCredentials: {
          Path: 'https://login.windows.net/{0}/oauth2/token',
          Method: 'POST',
          Authorization: true,
          PathParams: {
            Domain: 'default',
          },
        },
      },
    };
    const requestConfiguration = new RequestConfiguration(fakeSDKConfiguration);

    requestConfiguration.setApi('UserCredentials');
    try {
      requestConfiguration.getOptions({ bodyParams: 'value' });
    } catch (error) {
      assert(error.message === 'Expected bodyParams to be an object');
      done();
    }
  });
});
